/**
 * A prévia da agenda no painel: as três próximas datas e a quanto tempo faltam.
 *
 * É o `CalendarPreview` de `lib/features/dashboard/presentation/widgets/
 * calendar_preview.dart`, com a mesma janela de 30 dias, o mesmo âmbar e as
 * mesmas palavras. Faltava inteira aqui: quem abria o site só via as datas
 * entrando no calendário, nunca no painel.
 */

import { useMemo } from 'react';
import {
  COLECOES,
  compromissoDeMapa,
  iconeDoCompromisso,
  proximosCompromissos,
  quandoEmPalavras,
  traduzir,
  usarColecao,
} from '@nosso-sempre/shared';
import { Icone } from './Icone';
import { Secao, SetaDaSecao } from './Secao';
import './previas.css';

export function PreviaDaAgenda() {
  const docs = usarColecao<Record<string, unknown>>(COLECOES.agenda);

  const proximos = useMemo(() => {
    const compromissos = docs.map((d) => compromissoDeMapa(d.id, d.dados));
    return proximosCompromissos(compromissos, 30).slice(0, 3);
  }, [docs]);

  const legenda =
    proximos.length === 0
      ? traduzir('nada marcado')
      : proximos.length === 1
        ? traduzir('a próxima data')
        : `as próximas ${proximos.length} datas`;

  return (
    <Secao
      icone="calendario"
      cor="var(--ambar)"
      titulo={traduzir('Próximas datas')}
      legenda={legenda}
      para="/calendario"
      ponta={<SetaDaSecao />}
    >
      {proximos.length === 0 ? (
        <p className="previa-convite">
          <Icone nome="mais-circulo" tamanho={18} />
          {traduzir('Planeje o próximo dia especial')}
        </p>
      ) : (
        <ul className="previa-agenda">
          {proximos.map((e) => (
            // A repetição traz o mesmo `id` em datas diferentes, então a data
            // entra na chave — sem ela o React descartaria as ocorrências.
            <li key={`${e.id}-${e.quando.getTime()}`}>
              <span className="previa-agenda-selo" aria-hidden="true">
                <Icone nome={iconeDoCompromisso(e.tipo)} tamanho={16} />
              </span>
              <span className="previa-agenda-nome">{e.titulo}</span>
              <span className="previa-agenda-quando">{quandoEmPalavras(e.quando)}</span>
            </li>
          ))}
        </ul>
      )}
    </Secao>
  );
}
